import React, { FC } from 'react'
import { IconProps } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import { Sync } from './Sync'

export const AnimatedSync: FC<IconProps> = (props) => {
    return (
        <motion.div
            animate={{ rotate: -360 }}
            style={{ display: 'inline-block', lineHeight: '0px' }}
            transition={{ duration: 4, loop: Infinity, ease: 'linear' }}
        >
            <Sync {...props} />
        </motion.div>
    )
} 